import LinearProgress from '@mui/material/LinearProgress';
import React from 'react';
import { useParams } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';
import { checkAccess } from '../api/mobileapi';
import { AccessPointData } from '../api/types';
import { GlobalError } from '../components/GlobalError/GlobalError';
import { useHomeData } from '../components/LoadHomeData/HomeDataProvider';
import { PermissionsNotFound } from '../components/Permissions/PermissionsNotFound';
import { RequestAccess } from '../components/RequestAccess/RequestAccess';
import { useTranslations } from '../components/Translations/TranslationsProvider';
import { AdamsError } from '../utils/errors';

export const RequestAccessPage = () => {
    const { currentLanguage } = useHomeData();
    const { accesspointcode, permissionid } = useParams();
    const { translations } = useTranslations();

    const {
        data: accessInformation,
        error: accessPointError,
        isLoading,
    } = useQuery<AccessPointData, AdamsError>(
        ['checkAccess', accesspointcode],
        () => checkAccess({ language: currentLanguage, accessPointCode: accesspointcode! }),
        {
            enabled: !!accesspointcode,
        }
    );

    if (!accessPointError && (!accessInformation || !translations || isLoading)) {
        return <LinearProgress />;
    }

    if (accessPointError) {
        return <GlobalError error={accessPointError} translations={translations} />;
    }

    const permissionInfo = accessInformation.permissions.find(({ permissionCode }) => permissionCode === permissionid);

    if (!permissionInfo) {
        return <PermissionsNotFound accessPointCode={accessInformation.accessPointCode} translations={translations} />;
    }

    return (
        <RequestAccess
            accessInformation={accessInformation}
            permissionInfo={permissionInfo}
            translations={translations}
        />
    );
};
